module.exports = "<p>empresas-seguras works!</p>\n"